import * as React from "react";
const Bezorgen = () => (
  <svg
    width={16}
    height={12}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.8 1.8c0-.55.425-1 1-1h8.4c.55 0 1 .45 1 1v6.6H7.025A2.01 2.01 0 0 0 5.2 7.2c-.675 0-1.25.325-1.6.8-.375-.475-.95-.8-1.6-.8-.45 0-.875.15-1.2.4zm12.4 5.4c-.45 0-.875.15-1.2.4v-2h3.2v2.6c0 .1-.075.2-.175.2C14.7 7.7 14 7.2 13.2 7.2M12 4.8V3.2h1.4c.125 0 .225.075.3.175L14.8 4.8zm4 3.4V5.475c0-.25-.1-.5-.25-.725l-1.4-1.85c-.225-.3-.575-.5-.95-.5H12v-.6c0-.975-.825-1.8-1.8-1.8H1.8C.8 0 0 .825 0 1.8v7.4c0 1.125.875 2 2 2 .65 0 1.225-.3 1.6-.8.35.5.925.8 1.6.8 1.1 0 2-.875 2-2h4c0 1.125.875 2 2 2 1.1 0 2-.875 2-2 .45-.1.8-.5.8-1m-1.775 1.6a1.197 1.197 0 0 1-2.075 0 1.15 1.15 0 0 1 0-1.2c.225-.35.6-.6 1.05-.6.425 0 .8.25 1.025.6.225.375.225.85 0 1.2M5.8 8.175c.35.225.6.6.6 1.025 0 .45-.25.825-.6 1.05a1.15 1.15 0 0 1-1.2 0 1.197 1.197 0 0 1 0-2.075 1.15 1.15 0 0 1 1.2 0M3.025 9.8a1.197 1.197 0 0 1-2.075 0 1.15 1.15 0 0 1 0-1.2c.225-.35.6-.6 1.05-.6.425 0 .8.25 1.025.6.225.375.225.85 0 1.2m4.096-5.086H6.032v-.65h1.904c0 1.235-.674 1.984-1.79 1.984-.957 0-1.794-.695-1.794-1.791s.837-1.793 1.863-1.793c.722 0 1.177.363 1.439.774l-.612.333a1 1 0 0 0-.827-.452c-.639 0-1.1.483-1.1 1.138s.462 1.137 1.1 1.137c.497 0 .796-.317.906-.68"
      fill="#000"
    />
  </svg>
);
export default Bezorgen;
